import { createContext } from 'react'
import { Store } from 'components/common/filters/select-store'
import { Team } from '../../../components/common/filters2/filters/select-team'
export type StoreTeamSwitchAggregation = 'STORE' | 'TEAM'
export type HomePageChannel = 'INSTORE' | 'OMNI'

export interface HomeState {
  channel: HomePageChannel
  aggregation: StoreTeamSwitchAggregation
  storeId: number | null
  teamId: number | null
  store: Store | null
  team: Team | null
  userFirstName: string
  templates: TemplateIdentity[]
  setChannel: (value: HomePageChannel) => void
  setAggregation: (value: StoreTeamSwitchAggregation) => void
  setTeamId: (teamId: number) => void
}

export interface TemplateIdentity {
  id: number
  label: string
}
export const HomeContext = createContext<HomeState | undefined>(undefined)
